module.exports = __webpack_public_path__ + "static/media/logo_hooli@2x.3c41bdd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/logos/logo_hooli@2x.png
// module id = 345
// module chunks = 0